import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/3WJQExEmQTNa7WyTswVmJH/90a441_ac38cf4788a84bddb3313c14f9cf494e~mv2.png', 'https://cdn.magicpatterns.com/uploads/1dTU6FVJBWESEEnsJ6p27L/505430811_1188096266677823_2026716908309487568_n.jpg', 'https://cdn.magicpatterns.com/uploads/ktCNx662T3HB1cD2mLSoA8/90a441_cb745a4a7b4c425ea67add0e086b5726~mv2.png', 'https://cdn.magicpatterns.com/uploads/59hM2Dws9qEi3MNm4uuXmK/90a441_6c3b28ed273d40dc84e9cdd6db1997eb~mv2.png', 'https://cdn.magicpatterns.com/uploads/qNyWcruiipFRdCRjaRU2dh/505822966_1188096186677831_6919732715312370453_n.jpg', 'https://cdn.magicpatterns.com/uploads/kneaN3diP3m3fisvU4kHmw/505576870_1188096240011159_4179226309746543937_n.jpg' // Orange Lambo Shop
];
export function PhotoGallery() {
  return <section id="gallery" className="py-24 bg-[#1a1a1a]" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-153">
          <div data-id="element-154">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-155">
              Recent Projects
            </h2>
            <div className="w-20 h-1 bg-[#c41e3a]" data-id="element-156" />
          </div>
          <a href="#" className="hidden md:flex items-center text-[#c41e3a] hover:text-white transition-colors font-bold uppercase tracking-wider text-sm mt-4 md:mt-0" data-id="element-157">
            View Full Gallery <ArrowRight className="ml-2 w-4 h-4" data-id="element-158" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-159">
          {images.map((src, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="relative overflow-hidden group rounded-sm aspect-[4/3]" data-id="element-160">
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/0 transition-colors duration-500 z-10" data-id="element-161" />
              <img src={src} alt="Exotic Car Repair" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-162" />
            </motion.div>)}
        </div>

        <div className="mt-8 md:hidden text-center" data-id="element-163">
          <a href="#" className="inline-flex items-center text-[#c41e3a] hover:text-white transition-colors font-bold uppercase tracking-wider text-sm" data-id="element-164">
            View Full Gallery <ArrowRight className="ml-2 w-4 h-4" data-id="element-165" />
          </a>
        </div>
      </div>
    </section>;
}